"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loading = void 0;
const preact_1 = require("preact");
const style_1 = require("./style");
const itemTypeGroupName = {
    replay: 'Replay',
    bsp: 'Map',
    sound: 'Sounds',
    sky: 'Skybox',
    sprite: 'Sprites',
    wad: 'Wads'
};
class Loading extends preact_1.Component {
    constructor() {
        super(...arguments);
        this.state = {
            items: {}
        };
        this.onItemLoad = (item) => {
            const items = this.state.items[item.type] ? this.state.items[item.type] : [];
            for (let i = 0; i < items.length; ++i) {
                if (items[i] === item) {
                    return;
                }
            }
            items.push({
                name: item.name,
                progress: 0
            });
            this.setState({
                items: Object.assign(Object.assign({}, this.state.items), { [item.type]: items })
            });
        };
        this.onItemProgress = (item) => {
            if (!this.state.items[item.type]) {
                return;
            }
            const items = this.state.items[item.type];
            for (let i = 0; i < items.length; ++i) {
                if (items[i].name === item.name) {
                    items[i].progress = item.progress;
                    break;
                }
            }
            this.forceUpdate();
        };
    }
    componentDidMount() {
        const loaderEvents = this.props.game.loader.events;
        this.offLoadStart = loaderEvents.on('loadstart', this.onItemLoad);
        this.offProgress = loaderEvents.on('progress', this.onItemProgress);
    }
    componentWillUnmount() {
        this.offLoadStart && this.offLoadStart();
        this.offProgress && this.offProgress();
    }
    formatItem(name, progress) {
        name = itemTypeGroupName[name];
        const status = Math.round(progress * 100) + '%';
        let length = 29 - name.length - status.length;
        if (length < 2) {
            length = 9 - status.length;
        }
        const dots = Array(length).join('.');
        return `${name}${dots}${status}`;
    }
    render() {
        return ((0, preact_1.h)("div", { class: this.props.visible ? style_1.LoadingStyle.loading : style_1.LoadingStyle.loadingHidden },
            (0, preact_1.h)("div", { class: style_1.LoadingStyle.spinner },
                (0, preact_1.h)("svg", { xmlns: "http://www.w3.org/2000/svg", x: "0px", y: "0px", width: "80px", height: "80px", viewBox: "0 0 80 80", xmlSpace: "preserve" },
                    (0, preact_1.h)("path", { fill: "#ffffff", width: "10px", d: "M40,72C22.4,72,8,57.6,8,40C8,22.4,22.4,8,40,8c17.6,0,32,14.4,32,32c0,1.1-0.9,2-2,2s-2-0.9-2-2c0-15.4-12.6-28-28-28S12,24.6,12,40s12.6,28,28,28c1.1,0,2,0.9,2,2S41.1,72,40,72z" }))),
            (0, preact_1.h)("ul", { class: style_1.LoadingStyle.log }, Object.entries(this.state.items).map(([name, items]) => ((0, preact_1.h)("li", { key: name, class: style_1.LoadingStyle.logItem }, this.formatItem(name, items.reduce((prev, cur) => prev + cur.progress, 0) /
                items.length)))))));
    }
}
exports.Loading = Loading;
